import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

const APP_ID = 'c38c4594-4c2b-4aaa-8561-420cdeaa3565';
const ANDROID_CHANNEL_ID = '428e7aab-7bb2-408b-adc3-c6af6e5994d8';

@Injectable({
  providedIn: 'root',
})
export class PushService {
  constructor(private httpClient: HttpClient) {}

  sendPush(pushId: Array<string>, title: string, message: string, data?: any) {
    return new Promise<any>((resolve, reject) => {
      const httpOptions = {
        headers: {
          //onesignal에서 제공하는 기본 셋팅
          Authorization: 'Bearer MmZmYWE3Y2UtZGQ1NS00NDY4LWFmNWUtNzFhMTFjNzM4MmVh',
          'Content-Type': 'application/json; charset=utf-8',
        },
      };
      // 'undefined' 문자열을 제거
      pushId = pushId.filter(id => id !== 'undefined');

      let body = {
        //push 정보
        app_id: APP_ID,
        headings: { en: 'Picket' || title },
        contents: { en: message },
        data: { url: data.url },
        include_player_ids: pushId,
        android_channel_id: ANDROID_CHANNEL_ID,
        ios_badgeType: 'Increase',
        ios_badgeCount: 1,
      };

      if (pushId?.length > 0) {
        //로그인을 했을 경우에만
        this.httpClient.post('https://onesignal.com/api/v1/notifications', body, httpOptions).subscribe(
          data => {
            resolve(data);
          },
          error => {
            reject(error);
          }
        );
      }
    });
  }
}
